import "./app.css";

import { initCommon } from "./js/common";
import { initSwiper } from "./js/swiper";
import { initTabSystem } from "./js/tabSystem";
import { initTop } from "./js/top";
import { initAnimation } from "./js/animation";

document.addEventListener("DOMContentLoaded", () => {
	initCommon();
	initAnimation();
	initSwiper();
	initTabSystem();
	initTop();
});
